<template>
  <div class="primeiro-acesso-container">
    <div class="termo-de-uso" v-if="open">
      <termos-de-uso
        :id-termo="idTermo"
        :verificarDataAceite="false"
        @voltar="open = false"
      />
    </div>
    <div v-show="!open" class="content">
      <FuncionalidadeHeader
        v-if="primeiroAcessoData.parametros.textos.tituloNavegacao"
        :titulo="primeiroAcessoData.parametros.textos.tituloNavegacao"
        :custom-voltar="true"
        :info="false"
        :login="true"
        @click="voltar"
      />
    <p
      v-if="primeiroAcessoData.parametros.textos.cabecalho"
      class="primeiro-acesso-cabecalho"
    >
      {{primeiroAcessoData.parametros.textos.cabecalho}}
    </p>

    <div
      id="form-render"
    />

    <p
      v-if="primeiroAcessoData.parametros.textos.rodape"
      class="primeiro-acesso-rodapé"
    >
      {{primeiroAcessoData.parametros.textos.rodape}}
    </p>
    <AlertaErro
      v-model="erro.show"
      :title="erro.titulo"
      :description="erro.descricao"
    />
    <termo-de-uso-combobox :id-termo="idTermo" v-model="checked" ref="termoBox" @click="open = true" :open-termos="open"></termo-de-uso-combobox>
    <ButtonDefault
      :title="primeiroAcessoData.parametros.textos.botaoEnviar"
      @click="enviar"
      :disabled="!checked"
    />
    </div>
    <DialogDefault
      :open.sync="mostrarErro.show"
      title="Atenção"
      width="370px"
      @close="mostrarErro.show = false"
      :close-on-click-modal="false"
    >
      <div>
        <div
          style="text-align: center; font: normal normal normal 14px/19px Open Sans; letter-spacing: 0; color: #000000; opacity: 0.8;">
          {{mostrarErro.descricao}}
        </div>
        <ButtonDefault title="ENTENDI" @click="voltar" />
      </div>
    </DialogDefault>
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapActions, mapGetters, mapState } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import TermoDeUsoCombobox from '@/components/TermosDeUso/TermosDeUsoCombobox'
import TermosDeUso from '@/components/TermosDeUso/TermosDeUsoComponent'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'Func134',
  components: {
    DialogDefault,
    TermoDeUsoCombobox,
    TermosDeUso,
    FuncionalidadeHeader,
    AlertaErro,
    ButtonDefault
  },
  data () {
    return {
      form: {},
      open: false,
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: ''
      },
      checked: false,
      mostrarErro: {
        show: false,
        descricao: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    primeiroAcessoData () {
      return this.config.configuracaoAcesso.primeiroAcesso
    },
    idTermo () {
      return this.primeiroAcessoData.parametros.idTermosUso
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      this.initForm()
    },
    initForm () {
      const formId = this.primeiroAcessoData.parametros.formularios.formPrimeiroAcesso

      const id = `form-render`

      // postman > usario unificado > omni usuario > carrega sessão usuãrio
      let params = {
        identifier: id,
        clientKey: this.config.aplicacao.clientKey,
        'idForm': formId,
        'colors': { ...this.formBuilderColors }
      }
      this.form = renderForm(params)
      this.form.on('LOADING', res => {
        this.internalLoading = res
      })
    },
    showError () {
      this.erro.descricao = `<ul>
  <li>CPF</li>
  <li>Senha</li>
</ul>`
      this.erro.show = true
    },
    async enviar () {
      this.erro.show = false

      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        return this.showError()
      }

      const payload = formData.data

      // const response = await this.apiAcesso.login.login({ payload, loading: true })
      const response = await this.apiAcesso.primeiroAcesso.primeiroAcesso({
        payload,
        loading: true,
        notifyFailure: false,
        notifySuccess: true,
        handlerErrorIgnore: true
      })

      if (response.status) {
        this.setLogin(response)

        await this.$refs.termoBox.aceitarTermo()

        this.sendLoginMessage(response)
      } else {
        if (response.code === 400) {
          this.mostrarErro.show = true
          this.mostrarErro.descricao = response.message
        } else {
          this.erro.descricao = `<ul><li>${response.message}</li></ul>`
          this.erro.show = true
        }
      }
    },
    sendLoginMessage (data) {
      const payload = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'LOGIN',
        data,
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    },
    voltar () {
      return this.$router.push({ path: '/9' })
    }
  }
}
</script>

<style scoped>
.primeiro-acesso-container {
  max-width: 450px;
  margin: 0 auto;
}

.primeiro-acesso-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin: 0 0 15px;
}

.primeiro-acesso-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px;
}
</style>
